export default __webpack_public_path__ + "static/media/sketch-tool.327fca28.png";